// src/components/BeneficeSection.js
import React from "react";
import "../App.css";
import "./BeneficeSection.css";
import { Link } from "react-router-dom";
import { Button } from "./Button"; // adjust path if needed

function BeneficeSection() {
  const benefits = [
    {
      image: "/images/360-kuula-services.png",
      title: "Immersive 360° Tours",
      text: "Give clients the ability to explore every angle of a property remotely by offering an interactive experience, you build trust faster, and shorten the decision-making cycle turning interest into sales and bookings at scale.",
      link: "/portfolio?filter=360",
      cta: "View Tours",
    },
    {
      image: "/images/drone-page-services.png",
      title: "Cinematic Drone Footage",
      text: "Showcase scale, setting, and lifestyle from above. Drone footage elevates your property beyond the ordinary, it gives buyers perspective, ignites curiosity, and positions your listing as a premium opportunity.",
      link: "/portfolio?filter=Drone",
      cta: "See Drone Shots",
    },
    {
      image: "/images/videography-services.png",
      title: "High-Impact Video",
      text: "Tell the story of your property in motion. From first glance to final frame, our cinematic productions are designed to hold attention and spark connection.",
      link: "/portfolio?filter=Video",
      cta: "Watch Videos",
    },
    {
      image: "/images/photo-services.jpg",
      title: "Professional Photography",
      text: "Our photography captures detail, light, and atmosphere with precision ensuring your property isn’t just seen, but remembered. The result are visuals that inspire confidence and move buyers closer to action.",
      link: "/portfolio?filter=Photo",
      cta: "Browse Photos",
    },
    {
      image: "/images/floormeasure.png",
      title: "Floor Measurements & Coverings",
      text: "Complete documentation in one visit. We capture each room’s dimensions and flooring details. Ensuring accuracy, consistency, and time saved for your next project.",
      link: "/portfolio?filter=Photo",
      cta: "See Portfolio",
    },
  ];

  return (
    <div className="benefice-section">
      {benefits.map((item, index) => (
        <div key={index} className="benefice-card">
          <div className="benefice-image">
            <img src={item.image} alt={item.title} />
          </div>
          <div className="benefice-content">
            <h1>{item.title}</h1>
            <p>{item.text}</p>
            <div className="benefice-btn">
              <Link to={item.link}>
                <Button
                  buttonStyle="fm-btn--outline"
                  buttonSize="fm-btn--medium"
                >
                  {item.cta}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default BeneficeSection;
